import { ErrorService } from '../error/error.service';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { User, UserStatus } from '../data/user/user.model';
import { BehaviorSubject } from "rxjs";
import { AuthenticationStorage } from "./authentication-storage.service";
import { AuthenticationHttpService } from "./authentication-http.service";
import { NavController } from 'ionic-angular';

@Injectable()
export class AuthenticationService {
  public userStatus$: Observable<UserStatus>;
  public userUid$: Observable<any>;
  public currentUser$: Observable<any>; 

  private userStatusSubject: BehaviorSubject<UserStatus> = new BehaviorSubject(UserStatus.unlogged);
  private userUidSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  private currentUserSubject: BehaviorSubject<User> = new BehaviorSubject(null);

  public nav: NavController;

  constructor(
    private authHttp: AuthenticationHttpService,
    private authStorage: AuthenticationStorage,
    private error: ErrorService
  ){
    this.userStatus$ = this.userStatusSubject.asObservable();
    this.userUid$ = this.userUidSubject.asObservable();
    this.currentUser$ = this.currentUserSubject.asObservable();

    this.authStorage.getUid().then((uid) => {
      if(uid){
        this.userStatusSubject.next(UserStatus.exists);
        this.userUidSubject.next(uid);
      } else {
        this.userStatusSubject.next(UserStatus.unlogged);
      }
    }).catch(error => {
      console.error(error);
    })
  }

  login(email: string, password: string){
      this.authHttp.login(email, password)
      .catch(e => {
        this.error.addError(e.error)
        return Observable.of(null);
      })
      .subscribe((user: User) => {
        /**
         * Insert user login information inside the storage
        */
        if(user && user.active === false){
          this.error.addError('USER_NOT_ACTIVE');
          return Observable.of(null);
        } 
        if(user !== null && user.active === true ){
          this.authStorage.setToken(user.apiToken);
          this.authStorage.setRefreshToken(user.apiRefreshToken);
          this.authStorage.setTokenExpiration(user.apiTokenExpiration);
          this.authStorage.setUid(user._id),
          this.currentUserSubject.next(user);
          this.userUidSubject.next(user._id);
        }
    });
  }

  registration(username: string, password: string, email: string, privacy: boolean){
    this.authHttp.registation(username, password, email, privacy)
    .catch(e => {
      this.error.addError(e.error)
      return Observable.of(null);
    })
    .subscribe(async (user: User) => {
      if(user !== null){
        await Promise.all([
          this.authStorage.setToken(user.apiToken),
          this.authStorage.setRefreshToken(user.apiRefreshToken),
          this.authStorage.setTokenExpiration(user.apiTokenExpiration),
          this.authStorage.setUid(user._id),
        ]);
        this.currentUserSubject.next(user);
        this.userUidSubject.next(user._id);
      } else {
        this.error.addError('REGISTRATION_ERROR');
        this.currentUserSubject.next(null);
      }
    })
  }

  resendEmail(email: string, resend: boolean){
    this.authHttp.resendEmail(email, resend) 
    .catch(e => {
      this.error.addError(e.error)
      return Observable.of(null);
    })
  }

  resetPassword(email: string, reset: boolean){
    this.authHttp.resetPassword(email, reset)
    .catch(e => {
      this.error.addError(e.error)
      return Observable.of(null);
    })
    .subscribe(e => {
      if(e !== null){
        this.error.addError('CHECK_YOUR_EMAIL');
      }
      
    })
  }

  updateCurrentUser(user: User) {
    this.currentUserSubject.next(user);
  }
  logOut(){;
    this.authStorage.deleteAll();
    this.currentUserSubject.next(null);
  }
}


// WEBPACK FOOTER //
// ./src/app/core/authentication/authentication.service.ts